import { t } from '../core/i18n.js';
import { escapeHtml } from '../core/utils.js';
import { openExternal } from '../core/external.js';
import { openReport } from './report.js';

/* Créditos de las fuentes públicas y de los datos que usa la app: cada una es una fila que abre su página. */

export const CREDITS = [
    { id: 'iptv-org', name: 'iptv-org', role: 'creditRole.channels', url: 'https://github.com/iptv-org/iptv', icon: 'public' },
    { id: 'tdtchannels', name: 'TDTChannels', role: 'creditRole.tdt', url: 'https://www.tdtchannels.com', icon: 'tv' },
    { id: 'archive', name: 'Internet Archive', role: 'creditRole.archive', url: 'https://archive.org', icon: 'theaters' },
    { id: 'tmdb', name: 'TMDB', role: 'creditRole.tmdb', url: 'https://www.themoviedb.org', icon: 'movie_filter' },
    { id: 'opensubtitles', name: 'OpenSubtitles', role: 'creditRole.subs', url: 'https://www.opensubtitles.com', icon: 'subtitles' }
];

let seq = 0;

export function openCredits() {
    const app = window.app;
    const id = 'credits-' + (++seq) + '-' + Date.now().toString(36);
    const rows = CREDITS.map((c) => `<a class="admin-user credit-row" href="#" data-url="${escapeHtml(c.url)}">
        <span class="admin-avatar mi">${c.icon}</span>
        <div class="admin-user-body">
            <div class="admin-user-name">${escapeHtml(c.name)}</div>
            <div class="admin-user-sub">${escapeHtml(t(c.role))}</div>
            <div class="admin-user-sub credit-url">${escapeHtml(c.url.replace(/^https?:\/\/(www\.)?/, ''))}</div>
        </div>
        <span class="mi">open_in_new</span>
    </a>`).join('');
    const html = `<div class="popup catpick-popup admin-popup" id="${id}">
        <div class="view">
            <div class="page">
                <div class="navbar"><div class="navbar-bg"></div><div class="navbar-inner">
                    <div class="title">${escapeHtml(t('settings.credits'))}</div>
                    <div class="right"><a href="#" class="link popup-close" aria-label="${escapeHtml(t('common.close'))}"><span class="mi">close</span></a></div>
                </div></div>
                <div class="page-content licadm-content">
                    <p class="px small muted">${escapeHtml(t('settings.creditsNotice'))}</p>
                    <div class="admin-list" data-list>${rows}</div>
                    <div class="licadm-more"><button type="button" class="btn btn-block" data-report><span class="mi">flag</span>${escapeHtml(t('report.title'))}</button></div>
                </div>
            </div>
        </div>
    </div>`;
    const popup = app.popup.create({
        content: html,
        on: {
            open(p) {
                p.el.querySelector('[data-list]').addEventListener('click', (e) => {
                    const a = e.target.closest('[data-url]');
                    if (!a) return;
                    e.preventDefault();
                    openExternal(a.getAttribute('data-url'), { title: a.querySelector('.admin-user-name').textContent });
                });
                p.el.querySelector('[data-report]').addEventListener('click', () => { popup.close(); setTimeout(() => openReport(), 250); });
                const first = p.el.querySelector('.credit-row');
                if (first && window.IPTV && window.IPTV.tvnav && (window.IPTV.device.isTV || !window.IPTV.device.hasTouch)) setTimeout(() => window.IPTV.tvnav.focusLayer(p.el, first), 80);
            },
            closed(p) { try { p.destroy(); } catch (e) { /* ya cerrado */ } }
        }
    });
    popup.open();
}
